export const style = {
  display: 'flex',
  height: '665px',
  width: '100%',
  margin: '0px auto',
  alignItems: 'flex-start',
  padding: '1px',
  maxWidth: '1060px',
};

export const pageSettings = {
  hideEventTypeDetails: false,
  hideLandingPageDetails: true,
};

export const options = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${process.env.CALENDLY_API_KEY}`,
  },
};

/* eslint-disable camelcase */

export const fetchApiforBuisnessName = async uri => {
  const response = await fetch(uri, options);
  const jsonResponse = await response.json();
  return jsonResponse.resource.questions_and_answers[0].answer;
};

export const fetchApiforStartTime = async uri => {
  const response = await fetch(uri, options);
  const jsonResponse = await response.json();
  return jsonResponse.resource.start_time;
};

/* eslint-enable camelcase */
